import { createEffect } from '../utils/store';

export const setToken = createEffect('SET_TOKEN');
export const login = createEffect('USER_LOGIN');
export const loginFail = createEffect('USER_LOGIN_FAIL');
export const logout = createEffect('USER_LOGOUT');
export const updateUser = createEffect('USER_UPDATE');
